import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import Typography from 'components/Typography';
import { CustomText } from 'components/CustomText';
import { Container } from './ShipmentDetails.styles';

interface ShipmentDetailsProps {
  isLoading: boolean;
  isNoShipment: boolean;
}
export const ShipmentDetails = ({
  isLoading,
  isNoShipment,
}: ShipmentDetailsProps): JSX.Element => {
  const { t } = useTranslation();
  const {
    merchantCustom: { noInfoDisplayMessage },
    loadingScreen: { message: loadingMessage },
  } = usePTPConfigContext();

  if (isLoading) {
    return (
      <Container>
        <CustomText
          as={Typography}
          text={loadingMessage || t('LOOKING_FOR_PARCEL')}
          level="displayMd"
        />
      </Container>
    );
  }

  if (isNoShipment) {
    return (
      <Container data-testid="parcel-details-no-info">
        <CustomText
          as={Typography}
          text={noInfoDisplayMessage || t('NO_INFORMATION_MESSAGE_1')}
          level="displayMd"
        />
      </Container>
    );
  }

  return null;
};
